<template>
  <!-- https://medium.com/@pppped/how-to-code-a-responsive-circular-percentage-chart-with-svg-and-css-3632f8cd7705 -->
  <div class="status-circle-container" :style="`height: ${size || 70}px;`">
    <div
      v-for="n in (count || 5) "
      :key="`circle-segment-${n}`"
      class="status-circle-segment"
      :style="`
        transform: rotate(${(n - 1) * (360 / count)}deg);
        width:${size || 70}px;
        height:${size || 70}px;`"
    >
      <div :style="`transform: rotate(${(360 * space / 100) / 2}deg);`">
        <svg :width="size || 70" :height="size || 70" viewBox="0 0 36 36" >
          <!-- FILL -->
          <path
            class="status-circle-fill"
            :d="`M18 ${(inner_y + 2.0845) / 2}
              a ${(15.9155 + inner_radius) / 2} ${(15.9155 + inner_radius) / 2} 0 0 1 0 ${15.9155 + inner_radius}
              a ${(15.9155 + inner_radius) / 2} ${(15.9155 + inner_radius) / 2} 0 0 1 0 -${15.9155 + inner_radius}`"
            fill="none"
            :stroke="!is_stop
              ? color || '#000'
              : stop_color"
            :stroke-width="15.9155 - inner_radius"
            :stroke-dasharray="`
              ${(100 / (count || 5) - (space || 2)) * ((inner_radius_factor + 1) / 2 || .9)},
              100`"
            :stroke-dashoffset="`${
              (n > filled_count)
                ? (100 / (count || 5) - (space || 2)) * ((inner_radius_factor + 1) / 2 || .9)
                : 0
            }`"
          />
          <!-- OUTER CIRCLE LINE -->
          <path
            :d="`M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831`"
            fill="none"
            :stroke="color || '#000'"
            :stroke-width="stroke_width || 1"
            :stroke-dasharray="`
              ${100 / (count || 5) - (space || 2)},
              100`"
          />
          <!-- INNER CIRCLE LINE -->
          <path
            :d="`M18 ${inner_y}
              a ${inner_radius} ${inner_radius} 0 0 1 0 ${inner_radius * 2}
              a ${inner_radius} ${inner_radius} 0 0 1 0 -${inner_radius * 2}`"
            fill="none"
            :stroke="color || '#000'"
            :stroke-width="stroke_width || 1"
            :stroke-dasharray="`
              ${(100 / (count || 5) - (space || 2)) * (inner_radius_factor || .8)},
              100`"
          />
          <!-- LEFT END -->
          <line
            x1="18"
            y1="2.0845"
            x2="18"
            :y2="line1_y2"
            :stroke="color || '#000'"
            :stroke-width="stroke_width || 1"
            stroke-linecap="round"
          />
          <!-- RIGHT END -->
          <line
            :x1="line2_x1"
            :y1="line2_y1"
            :x2="line2_x2"
            :y2="line2_y2"
            :stroke="color || '#000'"
            :stroke-width="stroke_width || 1"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
    <div
      class="status-circle-content"
      :style="`
        width: ${size || 70}px;
        height: ${size || 70}px;`"
    >
      <slot
        name="content"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'filled_count', // is number, contains how many segments are filled
      'is_stop', // is boolean, sets alternative display
      'size', // is number, contains pixel size of circle
      'color', // is string, contains color as hexcode (for example '#000')
      'stop_color', // is string, contains stop status color as hexcode (for example '#F00')
      'count', // is number, contains segment count
      'stroke_width',
      'inner_radius_factor', // is number, contains scale of inner radius (for example '.9')
      'space', // is number, contains space between segments
    ],

    computed: {
      line1_y2 () {
        return (36 - this.inner_radius * 2) / 2;
      },

      line2_x1() {
        let mid_x = 18;
        let percent = (100 / (this.count || 5) - (this.space || 2));
        let angle = (90 - (360 * percent / 100)).toFixed(4);
        return mid_x + (this.inner_radius * Math.cos(angle * Math.PI / 180));
      },

      line2_y1() {
        let mid_y = 18;
        let percent = (100 / (this.count || 5) - (this.space || 2));
        let angle = (90 - (360 * percent / 100)).toFixed(4);
        return mid_y - (this.inner_radius * Math.sin(angle * Math.PI / 180));
      },

      line2_x2() {
        let mid_x = 18;
        let percent = (100 / (this.count || 5) - (this.space || 2));
        let angle = (90 - (360 * percent / 100)).toFixed(4);
        return mid_x + (15.9155 * Math.cos(angle * Math.PI / 180));
      },

      line2_y2() {
        let mid_y = 18;
        let percent = (100 / (this.count || 5) - (this.space || 2));
        let angle = (90 - (360 * percent / 100)).toFixed(4);
        return mid_y - (15.9155 * Math.sin(angle * Math.PI / 180));
      },

      inner_radius() {
        return 15.9155 * (this.inner_radius_factor || .8);
      },

      inner_y() {
        return (36 - (this.inner_radius * 2)) / 2;
      }
    },

    data: () => ({

    }),

    methods: {

    },
  }
</script>

<style>
.status-circle-container {
  display: flex;
  justify-content: center;
}
.status-circle-segment,
.status-circle-content {
  position: absolute;
  overflow: hidden;
}
.status-circle-fill {
  transition:
    stroke-dashoffset 0.5s ease-in-out,
    stroke .33s ease-in-out;
}
.status-circle-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
